import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "../../../Assets/Css/AddUpdateInvoice.scss";
import "react-toastify/dist/ReactToastify.css";
import { customStyle } from "../../../Components/Style";
import "../../../Assets/Css/AddUpdateShareHolder.scss";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom'
import {
  getShareholders,
} from "../../../Services/Shareholders/action";
import { FaTrashAlt } from "react-icons/fa";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { addPurchaseInvoiceValidation } from '../../../Validations/addPurchaseInvoiceValidation'
import { gapi } from 'gapi-script';
import {
  getPurchaseInvoices,
  addPurchaseInvoice,
  updatePurchaseInvoice,
} from "../../../Services/Invoices/action";

const AddUpdateShareHolder = (props) => {

  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [finalData, setFinalData] = useState({
    seller_name: "",
    item_name: "",
    invoice_total: "",
    gst_amount: "",
    shareholder: "",
    purchase_date: null,
    url: ""
  });

  const [isUpdate, setIsUpdate] = useState(false);
  const [purchaseInvoiceData, setPurchaseInvoiceData] = useState([]);
  const [shareholders, setShareholders] = useState([]);
  const [deletedItem, setDeletedItem] = useState({
    shareholders: [],
  })
  let [optionTypeShareHolders, setOptionTypeShareHolders] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  // const [fileLinks, setFileLinks] = useState(() => {
  //   const storedFileLinks = localStorage.getItem("fileLinks");
  //   return storedFileLinks ? JSON.parse(storedFileLinks) : [];
  // });
  const [fileLinks, setFileLinks] = useState([]);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);

  const CLIENT_ID = '508622851022-i7ae7rtq4k29idsoab45kacfqse36vbm.apps.googleusercontent.com';
  const API_KEY = 'AIzaSyDWLa7wFRodLX4TcsaZOUHsSOMLWRLE_ac';
  const SCOPES = 'https://www.googleapis.com/auth/drive.file';

  const purchaseInvoiceId = location?.state?.data?.checkbox?.value;
  const purchaseInvdata = location?.state?.data;
  useEffect(() => {
    props.getPurchaseInvoices();
    props.getShareholders();
  }, []);

  useEffect(() => {
    const storedFiles = JSON.parse(localStorage.getItem('fileLinks')) || [];
    setFileLinks(storedFiles);
  }, []);

  useEffect(() => {
    localStorage.setItem('fileLinks', JSON.stringify(fileLinks));
  }, [fileLinks]);

  useEffect(() => {
    fetchAllData()
  }, []);

  useEffect(() => {
    setPurchaseInvoiceData(props?.purchaseInvoice);
  }, [props?.purchaseInvoice]);

  const fetchAllData = async () => {
    try {
      await props.getPurchaseInvoices(location.search);
      await props.getShareholders(location.search);
      if (purchaseInvoiceId) {
        setIsUpdate(true);
      }
      // setShareholders(await props?.shareHolderDetails?.shareholders?.rows)
    } catch (error) {
      toast.error(error);
    }
  }

  const getShareHolderOption = () => {
    return props?.shareHolderDetails?.shareholders?.rows?.map((sh) => {
      return {
        value: sh,
        label: (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              width: "100%",
              margin: 0,
              padding: 0,
            }}
          >
            <div style={{
              display: "flex",
              flexWrap: "wrap"
            }}>
              <span style={{ marginRight: "10px" }}>{sh.name}</span>
            </div>
            <div>
            </div>
          </div>
        ),
      };
    })
  }

  useEffect(() => {
    const options = getShareHolderOption();
    if (isUpdate) {
      (async () => {
        const shIdMap = props?.purchaseInvoice?.filter((f) => f.id === purchaseInvoiceId).flatMap((sh) => sh?.purchaseinvShareholderMap?.map((item) => item.shareholder_id)).join(', ')
        let filteredOptions = await options?.filter(item => shIdMap.includes(item?.value?.id));

        filteredOptions = filteredOptions?.map((item) => {
          return {
            ...item,
            value: item.value,
          };
        });
        setShareholders(filteredOptions);
        setOptionTypeShareHolders(options?.filter(item => !shIdMap.includes(item?.value?.id)));
      })()
    }
    else {
      setOptionTypeShareHolders(options)
    }
  }, [props?.shareHolderDetails?.shareholders?.rows, isUpdate]);


  useEffect(() => {

    if (isUpdate) {
      const existingUrls = props?.purchaseInvoice?.filter((item) => item.id === purchaseInvoiceId)?.flatMap((item) => item?.purchaseinvoiceMap?.map((url) => url.url));
      const fileLinksArray = existingUrls.map((url) => ({
        name: fileLinks.filter((item) => item.link === url).flatMap((item) => item.name),
        link: url
      }));
      setFileLinks(fileLinksArray);
      setFinalData({
        seller_name: purchaseInvdata?.Seller?.value,
        item_name: purchaseInvdata?.['Item-Name']?.value,
        invoice_total: purchaseInvdata?.['Invoice-Total']?.value.split('₹')[1],
        gst_amount: purchaseInvdata?.Gst?.value.split('₹')[1],
        shareholder: purchaseInvdata?.['Share Holders']?.value,
        purchase_date: purchaseInvdata?.Date ? moment(purchaseInvdata?.Date?.value).toDate() : null,
        url: fileLinks?.map((link) => link?.link)
      });
      values.seller_name = purchaseInvdata?.Seller?.value;
      values.item_name = purchaseInvdata?.['Item-Name']?.value;
      values.invoice_total = purchaseInvdata?.['Invoice-Total']?.value.split('₹')[1];
      values.gst_amount = purchaseInvdata?.Gst?.value.split('₹')[1];
      values.shareholder = purchaseInvdata?.['Share Holders']?.value;
      values.purchase_date = purchaseInvdata?.Date ? moment(purchaseInvdata?.Date?.value).toDate() : null;
      values.url = fileLinks?.map((link) => link?.link)
    }
  }, [isUpdate]);


  let initalVal = {
    seller_name: "",
    item_name: "",
    invoice_total: "",
    gst_amount: "",
    shareholder: "",
    purchase_date: null,
    url: ""
  };

  // SUBMIT
  const handleOnSubmit = async () => {
    const { seller_name, item_name, invoice_total, gst_amount, url, purchase_date, shareholder, ...dataToBeUpdate } = finalData;

    try {
      if (isUpdate) {
        // Updation Logic
        let requestData = {
          ...dataToBeUpdate,
          seller_name,
          item_name,
          invoice_total,
          gst_amount,
          url,
          purchase_date,
          shareholder: shareholders.map((val) => {
            return {
              shareholder: val.value.name
            };
          })
        };
        props.updatePurchaseInvoice(purchaseInvoiceId, requestData);
      }
      else {
        // Creation / Add Logic
        let addData = {
          ...dataToBeUpdate,
          seller_name,
          item_name,
          invoice_total,
          gst_amount,
          url,
          purchase_date,
          shareholder: shareholders.map((val) => {
            return {
              shareholder: val.value.name
            };
          }),
        };

        props.addPurchaseInvoice(addData)
        values.seller_name = "";
        values.item_name = "";
        values.invoice_total = "";
        values.gst_amount = "";
        values.url = "";
        values.shareholder = "";
        values.purchase_date = null
      }
      await props.getPurchaseInvoices();
      setIsLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  }

  let { values, errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues: initalVal,
    validationSchema: isUpdate === false ? addPurchaseInvoiceValidation : '',
    onSubmit: handleOnSubmit
  });

  useEffect(() => {
    setFinalData({ ...values });
  }, [values]);

  const handleDeleteShareHolder = (valueToDelete) => {

    if (isUpdate) {
      let isDataPresent = props?.shareHolderDetails?.shareholders?.rows?.find(item => item.id == valueToDelete.value.id);
      if (isDataPresent) {
        const shareholdersId = props?.shareHolderDetails?.shareholders?.rows?.map((i) => i.id);
        // let deletes = valueToDelete.value.filter(item => shareholdersId.includes(item.id));
        let deleteField = { id: valueToDelete.value.id };
        setDeletedItem({
          ...deletedItem,
          shareholder: [...deletedItem["shareholders"], deleteField],
        });
      }
    }
    const filteredValues = shareholders?.filter((val) => val.value.id !== valueToDelete.value.id);
    setShareholders(filteredValues);
    const aleredyPresentShareHolder = optionTypeShareHolders.some(item => item.value.id === valueToDelete.value.id);
    if (aleredyPresentShareHolder === false) {
      optionTypeShareHolders = optionTypeShareHolders || [];
      valueToDelete.value.share_percentage = "";
      const data = [...optionTypeShareHolders, valueToDelete];
      let sortedData = data.sort((a, b) => a.value.id - b.value.id);
      setOptionTypeShareHolders(sortedData);
    }
  };

  // useEffect(() => {
  //   const start = () => {
  //     gapi.client.init({
  //       apiKey: API_KEY,
  //       clientId: CLIENT_ID,
  //       discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"],
  //       scope: SCOPES,
  //     }).then(() => {
  //       console.log("Gapi initialized.");
  //     }, error => {
  //       console.error("Error", error);
  //     });
  //   };
  //   gapi.load('client:auth2', start);
  // }, [API_KEY, CLIENT_ID]);

  useEffect(() => {
    const initializeGapiClient = async () => {
      try {
        await gapi.load('client:auth2', async () => {
          await gapi.client.init({
            apiKey: API_KEY,
            clientId: CLIENT_ID,
            discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"],
            scope: SCOPES,
          });

          const authInstance = gapi.auth2.getAuthInstance();
          if (!authInstance.isSignedIn.get()) {
            await authInstance.signIn();
          }

          const grantedScopes = authInstance.currentUser.get().getGrantedScopes();
          if (!grantedScopes.includes(SCOPES)) {
            await authInstance.currentUser.get().grant({ scope: SCOPES });
          }
        });
      } catch (error) {
        console.error("Error initializing GAPI client:", error);
        toast.error("Failed to initialize Google API client");
      }
    };

    initializeGapiClient();
  }, []);

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    setSelectedFiles(files);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);
  };

  const handleUpload = () => {
    if (selectedFiles.length > 0) {
      setIsLoadingFiles(true);
      selectedFiles.forEach(uploadFileToGoogleDrive);
    } else {
      console.log("Please Select Files");
    }
  };

  const uploadFileToGoogleDrive = (file) => {
    const metadata = {
      name: file.name,
      mimeType: file.type,
    };
    const accessToken = gapi.auth.getToken().access_token;

    // const accessToken = gapi.auth2.getAuthInstance().currentUser.get().getAuthResponse().access_token;


    const form = new FormData();
    form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
    form.append('file', file);

    fetch('https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart', {
      method: 'POST',
      headers: new Headers({ 'Authorization': 'Bearer ' + accessToken }),
      body: form,
    })
      .then(response => response.json())
      .then(data => {
        console.log('File uploaded successfully', data);
        const fileLink = `https://drive.google.com/file/d/${data.id}/view`;
        setFileLinks(prevLinks => [...prevLinks, { name: file.name, link: fileLink }]);
        setFinalData(prevData => ({
          ...prevData,
          url: [...prevData.url, { link: fileLink }]
        }));
        const existingFileLinks = JSON.parse(localStorage.getItem('fileLinks')) || [];

        const updatedFileLinks = [...existingFileLinks, { name: file.name, link: fileLink }];
        localStorage.setItem('fileLinks', JSON.stringify(updatedFileLinks));
      })
      .catch(error => {
        console.error('Error uploading File', error);
      });
  };


  const handleDeleteFileLink = (linkToDelete, index) => {
    // setFileLinks(prevLinks => prevLinks.filter(file => 
    //   file.link !== linkToDelete
    // ));
    // setFinalData(prevData => ({
    //   ...prevData,
    //   url: [...prevData.url, fileLinks?.filter(file =>
    //     file.link !== linkToDelete
    //   )]
    // }));
    setFileLinks(prevLinks => prevLinks.filter(file =>
      file.link !== linkToDelete
    ));

    setFinalData(prevData => ({
      ...prevData,
      url: fileLinks.filter((file, i) => file.link === linkToDelete)
    }));

    const existingFileLinks = JSON.parse(localStorage.getItem('fileLinks')) || [];
    const updatedFileLinks = existingFileLinks.filter(file => file.link !== linkToDelete);
    localStorage.setItem('fileLinks', JSON.stringify(updatedFileLinks));
  };

  return (
      <div className="addUpdateShareholder-main">
        <div className="page-title">
          <h4>{isUpdate ? "Update" : "Add"} Purchase Invoice</h4>
          <div className="edit-btn">
            <button className="custom-btn" type="submit" onClick={handleSubmit}>
              {props.loading ? <Spinner as="span" animation="border" className="custom-spinner" role="status" aria-hidden="true" /> : 'Save'}
            </button>
          </div>
        </div>
        <div className="content-part">
          <div className="row">
            <div className="col-lg-6">
              <div className="left-part" style={{ justifyContent: 'flex-start' }}>
                <div className="custom-row">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="input-group">
                        <h6 className="label">Seller Name</h6>
                        <input
                          disabled={isLoading}
                          type="text"
                          value={values.seller_name}
                          name="seller_name"
                          onChange={handleChange}
                          className="input-css"
                        />
                        {errors.seller_name && touched.seller_name ? (
                          <p className="error-text">{errors.seller_name}</p>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="input-group">
                        <h6 className="label">Item Name</h6>
                        <input
                          disabled={isLoading}
                          type="text"
                          value={values.item_name}
                          name="item_name"
                          onChange={handleChange}
                          className="input-css"
                        />
                        {errors.item_name && touched.item_name ? (
                          <p className="error-text">{errors.item_name}</p>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className="label">Invoice Amount</h6>
                        <input
                          disabled={isLoading}
                          type="text"
                          value={values.invoice_total}
                          name="invoice_total"
                          onChange={handleChange}
                          className="input-css"
                        />
                        {errors.invoice_total && touched.invoice_total ? (
                          <p className="error-text">{errors.invoice_total}</p>
                        ) : null}
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="input-group">
                        <h6 className="label">GST Amount</h6>
                        <input
                          disabled={isLoading}
                          type="text"
                          value={values.gst_amount}
                          name="gst_amount"
                          onChange={handleChange}
                          className="input-css"
                        />
                        {errors.gst_amount && touched.gst_amount ? (
                          <p className="error-text">{errors.gst_amount}</p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="left-part" style={{ justifyContent: 'flex-start' }}>
                <label className="labeling">
                  <div className="label-gap">Date</div>
                  <DatePicker
                    selected={values.purchase_date}
                    onChange={(date) => handleChange({ target: { name: "purchase_date", value: date } })}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                  />
                </label>
                <h6 className="label">Share Holders</h6>
                <Select
                  isMulti
                  disabled={isLoading}
                  styles={customStyle}
                  options={optionTypeShareHolders || []}
                  value={shareholders}
                  onChange={(value) => {
                    setShareholders(value);
                  }}
                  controlShouldRenderValue={false}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#5757fe",
                      primary: "#5757fe",
                    },
                  })}
                />
                <ul className="ListMenu">
                  {shareholders && shareholders?.map((selectedValue, index) => {
                    return <li key={index} style={{ display: "flex" }}>
                      {selectedValue.label}
                      <div>
                        <FaTrashAlt
                          style={{ marginLeft: "5px" }}
                          className="deleteIcon"
                          onClick={() => handleDeleteShareHolder(selectedValue)}
                        />
                      </div>
                    </li>
                  }
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="uploadFile-part">
          <div className="row">
            <div className="col-lg-6">
              <div className="drag-drop-part">
                <div style={{ padding: '20px' }}>
                  <div
                    onDrop={handleDrop}
                    onDragOver={(e) => e.preventDefault()}
                    onClick={() => document.getElementById('fileInput').click()}
                    style={{ width: '100%', height: '20vh', border: '2px dashed #000', display: 'grid', alignItems: 'center', justifyContent: 'center', marginBottom: '20px', cursor: 'pointer', padding: '20px' }}
                  >
                    {selectedFiles.length > 0 ? (
                      selectedFiles?.map((file, index) => (
                        <ul>
                          <li key={index}>{file.name}</li>
                        </ul>
                      ))
                    ) : (
                      <p style={{ textAlign: 'center', margin: 0 }}>Drag & drop files here, or click to select files</p>
                    )}
                  </div>

                  <input
                    type="file"
                    id="fileInput"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    multiple
                  />
                  <button className="btn btn-primary" onClick={handleUpload} style={{ display: 'block', marginTop: '20px' }}>
                    {fileLinks.length === 0 && isLoadingFiles ? (
                      < Spinner as="span" animation="border" className='custom-spinner' role="status" aria-hidden="true" />
                    ) : (
                      'Upload Files'
                    )}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="link-part">
                {fileLinks.map((file, index) => (
                  <div key={index} style={{ marginTop: '20px', display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <p>{file.name}</p>

                    <a href={file.link} target='_blank' rel="noopener noreferrer" className="ms-auto btn btn-primary text-decoration-none">Download</a>
                    <button className="btn btn-danger ms-3" onClick={() => handleDeleteFileLink(file.link, index)}>
                      Delete
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.shareholdersReducer.loading,
    shareHolderDetails: state.shareholdersReducer,
    success: state.shareholdersReducer.success,
    purchaseInvoice: state.invoicesReducer.purchaseInvoice,
  }
}

const mapDispatchToProps = {
  getShareholders: getShareholders,
  addPurchaseInvoice: addPurchaseInvoice,
  updatePurchaseInvoice: updatePurchaseInvoice,
  getPurchaseInvoices: getPurchaseInvoices,
}
export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateShareHolder);
